/** @format */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from 'components/Layout/Page';
import SearchFilterPanel from 'components/SearchFilterPanel';
import ImageCard from './ImageCard';

import { searchPropertiesApiService } from 'services/apiService';
import PageLoader from 'components/PageLoader';
import { LoaderButton } from 'components/ButtonSyncLoader';

import './styles.scss';

export default function SearchPage(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [isShowMoreLoading, setIsShowMoreLoading] = useState(false);
  const [propertiesData, setPropertiesData] = useState({
    paging: {}
  });
  const [properties, setProperties] = useState([]);
  const [filteringData, setFilteringData] = useState({
    statuses: []
  });

  let viewObjectUrl = props.t('lang_route:common_object_listing');

  const fetchData = async (
    page = 1,
    append = false,
    isFromShowMoreButton = false
  ) => {
    const handleLoadingIndicator = (loadingState) => {
      if (isFromShowMoreButton) {
        setIsShowMoreLoading(loadingState);
      } else {
        setIsLoading(loadingState);
      }
    };

    try {
      handleLoadingIndicator(true);

      const requestParams = {
        page
      };

      if (filteringData.statuses.length > 0) {
        requestParams.statuses = filteringData.statuses.join(',');
      }

      const response = await searchPropertiesApiService(requestParams);

      const { properties, paging } = response.data.data;
      setPropertiesData({
        paging
      });

      if (append) {
        setProperties((prevProperties) => [...prevProperties, ...properties]);
      } else {
        setProperties(properties);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      handleLoadingIndicator(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filteringData.statuses]);

  const SearchSection = () => {
    if (!isLoading) {
      return (
        <>
          <div className='search-page-top-section'>
            <h3 className='info-title'>
              {props.t('lang_common:search_page:info:title')}
            </h3>
            <p className='info-paragraph text2r'>
              {props.t('lang_common:search_page:info:text')}
            </p>
          </div>

          <div className='search-page-middle-section'>
            <h3 className='search-page-objects-title'>
              {props.t('lang_common:search_page:objects:title')}
            </h3>

            <SearchFilterPanel
              {...props}
              filteringData={filteringData}
              setFilteringData={setFilteringData}
            />

            <div className='search-page-objects-container'>
              {properties?.length &&
                properties.map((property, index) => {
                  return (
                    <Link
                      to={`${viewObjectUrl}/${property?.vitecObjectId}`}
                      key={index}>
                      <ImageCard
                        key={index}
                        type={property?.type}
                        location={property?.location}
                        price={property?.price}
                        startingPrice={property?.startingPrice}
                        finalPrice={property?.finalPrice}
                        bedrooms={property?.noOfBedrooms}
                        bathrooms={property?.noOfBathrooms}
                        dimensions={property?.livingSpace}
                        currency={props.t('lang_onboarding:currency')}
                        status={property?.status}
                        imageUrl={property?.imageUrl}
                        // onComplete={property?.onComplete}
                        isMobile={false}
                        translation={props.t('lang_common:object_listing')}
                        countryCode={property?.countryCode}
                        noOfRooms={property?.rooms}
                        monthlyFee={property?.monthlyFee}
                        address={property?.address}
                        brokerData={property?.broker}
                        extra={property?.extra}
                        bidSetting={property?.bidSetting}
                        areaSize={property?.dimensions}
                        buildingSize={property?.livingSpace}
                      />
                    </Link>
                  );
                })}
            </div>
          </div>
          <div className='search-page-fetch-more-container'>
            {propertiesData.paging?.totalNoOfPages !==
              propertiesData.paging?.page &&
              !isShowMoreLoading && (
                <button
                  className='btn btn-white btn btn-primary'
                  onClick={() => {
                    fetchData(propertiesData.paging?.page + 1, true, true);
                  }}>
                  {props.t(`lang_common:broker_profile.showmore.text`)}
                </button>
              )}

            <LoaderButton
              display={isShowMoreLoading}
              text={props.t('lang_common:broker_profile:showmore:loader:text')}
            />
          </div>
        </>
      );
    }

    return <></>;
  };

  return (
    <PageLayout mainContainerClassName='search-page' {...props}>
      {isLoading && (
        <div className='page-loader-container'>
          <PageLoader />
        </div>
      )}

      <SearchSection />
    </PageLayout>
  );
}
